module.exports = __webpack_public_path__ + "static/media/dado.776b0933.jpg";